import { type UseQueryResult, useQuery } from '@tanstack/react-query'
import { fetchApiWithToken, type ResponseError } from '~/api/utils'
import type { ContactResponse } from '../types'

export const useContact = ({
  id,
  showToast = true
}: {
  id?: number
  showToast?: boolean
}): UseQueryResult<ContactResponse, ResponseError> =>
  useQuery({
    queryKey: ['contacts', id],
    queryFn: () =>
      fetchApiWithToken<ContactResponse>({
        method: 'get',
        url: `/v1/contacts/${id}`,
        showToast
      }),
    enabled: !!id
  })
